"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AmsProjectManagement = function AmsProjectManagement(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "mt-16" : _ref$className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-20"
  }, children));
};

var _default = {
  type: AmsProjectManagement,
  props: {
    amsAction: "project-management",
    authLevel: 5
  },
  wrappers: ["ams-project-management"],
  children: [{
    type: "ams-requests"
  }, {
    type: "ams-send-invite"
  }, {
    type: "ams-user-search"
  }, {
    type: "ams-assign-to-project"
  }, {
    type: "ams-create-group"
  }, {
    type: "ams-groups-in-project"
  }]
};
exports["default"] = _default;